import PosQRCodeService from '@/api/PosQRCodeService'

export const transformQRCode = (item) => {
  return {
    id: item._id,
    appProvider: item.app_provider,
    qrCodeRefId: item.qrcode_ref_id,
    clientApproveAccessRequired: item.is_client_approve_access_required,
    clientApproveOrderRequired: item.is_client_approve_order_required,
    dateCode: item.date_code,
    qrCodeType: item.qrcode_type,
    branchId: item.branch_id,
    branchName: item.branch_name,
    shopId: item.shop_id,
    psId: item.ps_id,
    psCode: item.ps_code,
    tableNumber: item.table_number,
    createdBy: item.created_by,
    createdAt: item.created_at,
    expiredAt: item.expired_at,
    expireTimeMins: item.expire_time_mins,
    queueNumber: item.queue_number,
    qrCodeImageUrl: item.qrcode_image,
    isPaid: item.is_paid,
  }
}

const transformQRCodes = (data) => {
  return data.map(item => transformQRCode(item))
}

// initial state
const state = {
  qrcodes: [],
}

// getters
const getters = {}

// mutations
const mutations = {
  setQRCodes (state, data) {
    state.qrcodes = transformQRCodes(data)
  },
}

// actions
const actions = {
  async getPosQRCodes ({ commit }, params) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getQRCodes') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getQRCodes')

      const response = await PosQRCodeService.getList(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getQRCodes')

      result = response.data

      if (result.success) {
        commit('setQRCodes', result.data)
        this.dispatch('setPagination', result.meta)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async generatePosQRCode ({ commit }, data) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('generatePosQRCode') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'generatePosQRCode')

      const response = await PosQRCodeService.generate(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'generatePosQRCode')

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async deletePosQRCode ({ commit }, qrcodeId) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('deletePosQRCode') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'deletePosQRCode')

      const response = await PosQRCodeService.delete(qrcodeId)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'deletePosQRCode')

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/PosQRCode.js